import React from "react";
import { Link } from "react-router-dom";
import { Recycle, Zap, Users, ArrowRight, Heart } from "lucide-react";

export default function Manifesto() {
  return (
    <div className="fade-in has-bottom-nav" data-testid="manifesto-page">
      <section className="bg-black text-white py-16 lg:py-24">
        <div className="max-w-[1100px] mx-auto px-4 lg:px-8 text-center">
          <Heart size={32} strokeWidth={2.5} className="mx-auto mb-6" style={{color:"var(--color-mint)"}}/>
          <p className="label text-[color:var(--color-mint)] mb-4">Manifeste · v1</p>
          <h1 className="text-5xl lg:text-8xl font-black tracking-tighter leading-[0.95] mb-8">
            On ne <span className="text-[color:var(--color-mint)]">produit</span> pas.<br/>
            On fait <span className="text-[color:var(--color-coral)]">durer</span>.
          </h1>
          <p className="text-lg max-w-2xl mx-auto text-white/80 leading-relaxed">
            Fripri est une plateforme française qui croit que la mode n'a pas besoin d'usine pour exister. Elle a juste besoin d'articles bien faits, et de mains pour les transmettre.
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-4">
        <Pillar idx="01" icon={<Recycle size={32} strokeWidth={2}/>} title="Mode circulaire" body="Chaque article de seconde main vendu = 25 kg de CO₂ évités. La planète te dit merci."/>
        <Pillar idx="02" icon={<Zap size={32} strokeWidth={2}/>} title="0 frais cachés" body="Tu vends, tu encaisses tout. Pas de pourcentage. Pas d'arnaque." accent="mint"/>
        <Pillar idx="03" icon={<Users size={32} strokeWidth={2}/>} title="Communauté française" body="Des vendeurs vérifiés. Une équipe basée à Paris. Du support en français."/>
      </section>

      <section className="max-w-[900px] mx-auto px-4 lg:px-8 py-16">
        <div className="border-l-4 border-black pl-6 mb-12">
          <p className="label mb-3">№ 1</p>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tighter mb-4">La fast fashion, c'est fini.</h2>
          <p className="text-lg text-[color:var(--color-text-muted)] leading-relaxed">
            100 milliards de vêtements produits chaque année. La planète n'en peut plus. On propose autre chose : la circularité.
          </p>
        </div>
        <div className="border-l-4 border-[color:var(--color-coral)] pl-6 mb-12">
          <p className="label mb-3">№ 2</p>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tighter mb-4">Vendre = un geste fort.</h2>
          <p className="text-lg text-[color:var(--color-text-muted)] leading-relaxed">
            Mettre en vente un article, c'est l'extraire du déchet. C'est lui offrir une nouvelle scène. Fripri rend ce geste évident, simple, désirable.
          </p>
        </div>
        <div className="border-l-4 border-[color:var(--color-mint)] pl-6">
          <p className="label mb-3">№ 3</p>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tighter mb-4">Le style français, à l'infini.</h2>
          <p className="text-lg text-[color:var(--color-text-muted)] leading-relaxed">
            Des grands classiques aux drops de demain. On célèbre le rapport intime que la France entretient avec ses vêtements — libre, affirmé, durable.
          </p>
        </div>
      </section>

      <section className="bg-[color:var(--color-mint)] text-black py-16 lg:py-20 text-center">
        <h2 className="text-4xl lg:text-6xl font-black tracking-tighter mb-6">Rejoins le mouvement.</h2>
        <p className="text-lg mb-10 opacity-80">Plus de 32 000 articles déjà sauvés. Et le tien ?</p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Link to="/catalogue" className="btn btn-primary" data-testid="manifesto-cta-shop">Explorer <ArrowRight size={14} strokeWidth={3}/></Link>
          <Link to="/vendre" className="btn btn-ghost" data-testid="manifesto-cta-sell">+ Vendre</Link>
        </div>
      </section>
    </div>
  );
}

function Pillar({ idx, icon, title, body, accent }) {
  const bg = accent === "mint" ? "bg-[color:var(--color-mint)]" : "bg-white";
  return (
    <div className={`p-6 lg:p-8 border-2 border-black ${bg} card-hover`}>
      <p className="display-num text-3xl font-black mb-4">{idx}</p>
      <div className="mb-4">{icon}</div>
      <h3 className="text-2xl font-black tracking-tight mb-2">{title}</h3>
      <p className="text-sm text-[color:var(--color-text-muted)] leading-relaxed">{body}</p>
    </div>
  );
}
